import angular from 'angular';

/**
 * 99% stolen implementation of ngIf from angular's source
 * ifContent is basically an ngIf without the container element
 * helps heaps if wrapping in an ngIf div breaks layout e.g. flex
 */

export default function ifContent($animate, $compile) {
  'ngInject';

  return {
    transclude: true,
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link($scope, $element, $attr, ctrl, $transclude) {
      let block;
      let childScope;
      let previousElements;

      const $comment = angular.element($compile.$$createComment('ifContent', $attr.ifContent));
      $element.replaceWith($comment);

      $scope.$watch($attr.ifContent, (value) => {
        if (value) {
          if (!childScope) {
            $transclude((clone, newScope) => {
              childScope = newScope;
              clone[clone.length++] = $compile.$$createComment('end ifContent', $attr.ifContent);
              // Note: We only need the first/last node of the cloned nodes.
              // However, we need to keep the reference to the jqlite wrapper as it might be changed later
              // by a directive with templateUrl when its template arrives.
              block = { clone };
              $animate.enter(clone, $comment.parent(), $comment);
            });
          }
        } else {
          if (previousElements) {
            previousElements.remove();
            previousElements = null;
          }
          if (childScope) {
            childScope.$destroy();
            childScope = null;
          }
          if (block) {
            previousElements = getBlockNodes(block.clone);
            $animate.leave(previousElements).done((response) => {
              if (response !== false) previousElements = null;
            });
            block = null;
          }
        }
      });
    },
  };
}

function getBlockNodes(nodes) {
  // TODO(perf): update `nodes` instead of creating a new object?
  let node = nodes[0];
  const endNode = nodes[nodes.length - 1];
  let blockNodes;

  for (let i = 1; node !== endNode && (node = node.nextSibling); i++) {
    if (blockNodes || nodes[i] !== node) {
      if (!blockNodes) {
        blockNodes = angular.element([].slice.call(nodes, 0, i));
      }
      blockNodes.push(node);
    }
  }

  return blockNodes || nodes;
}
